export default () => ({
  companyStatitics: ''
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/components/statistics/resources/data.js